import { Button } from "@/components/ui/button";

/**
 * The edit/delete button that sits at the end of a list row.
 *
 * Two things differ between pointer and touch. A desktop row keeps its actions
 * dimmed until the row is hovered, which stops a long list from reading as a
 * wall of icons — but touch has no hover, so on a phone that styling would
 * leave the buttons permanently at 60% with no way to bring them up. And a
 * 32px control is comfortable for a mouse and too small for a thumb; 44px is
 * the accessibility floor, so the button grows wherever the pointer is a
 * finger.
 */
export default function RowActionButton({ danger = false, className = "", ...props }) {
  return (
    <Button
      variant="ghost"
      size="icon"
      className={`h-8 w-8 touch:h-11 touch:w-11 ${danger ? "text-expense hover:text-expense" : ""} ${className}`}
      {...props}
    />
  );
}

/** Wrapper for a row's action cluster: always visible on touch, hover-revealed with a mouse. */
export function RowActions({ className = "", children }) {
  return (
    <div className={`flex gap-1 opacity-60 transition-opacity group-hover:opacity-100 touch:gap-0.5 touch:opacity-100 ${className}`}>
      {children}
    </div>
  );
}
